import React from "react";
import { Col, Row } from "antd";
import { PopularCategory } from "../PopularCategory";
import styles from "./popularDesktop.scss";

const rowGutter: any = { xs: 4, sm: 4, md: 4, lg: 4, xl: 24 };

const PopularDesktop = ({ populars }) => {
  return (
    <Row type="flex" gutter={rowGutter} className={styles.row}>
      {populars.map((popular, index) => (
        <Col key={index} span={4} className={styles.popular}>
          <PopularCategory popular={popular} />
        </Col>
      ))}
    </Row>
  );
};

export default PopularDesktop;



// WEBPACK FOOTER //
// ./src/containers/HomePage/PopularCategories/PopularDesktop/PopularDesktop.tsx